module.exports = __webpack_public_path__ + "img/paypal.bfab828.jpg";